import { render, staticRenderFns } from "./role-form.component.vue?vue&type=template&id=60fd9e7f"
import script from "./role-form.component.vue?vue&type=script&lang=js"
export * from "./role-form.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports